import Vue from 'vue';

import './style.scss';

import FoldedCard from './folded-card.vue';
import PhotoCard from './photo-card.vue';
import CardLine from './card-line.vue';
import Carousel from './carousel.vue';
import Rotatoscope from './rotatoscope.vue';
import App from './app.vue';

function registerComponents(components) {
  Object.keys(components).forEach(name => {
    let tag = name[0].toLowerCase() + name.substr(1);
    tag = tag.replace(/([A-Z])/g, '-$1');
    tag = tag.toLowerCase();

    Vue.component(tag, components[name]);
  });
}
registerComponents({
  App, FoldedCard, PhotoCard, CardLine, Carousel, Rotatoscope
});


const vm = new Vue({
  el: "#app"
});


// WEBPACK FOOTER //
// ./src/main.js